import Button from "components/Button";
import React from "react";
import Edit from "icons/edit-white.svg";
import { useHistory } from "react-router-dom";

type Props = {
  version: string;
  id?: string;
  handleSubmit?: () => void;
};

const TermsVersion: React.FC<Props> = ({
  version,
  id,
  handleSubmit,
}): JSX.Element => {
  let history = useHistory();

  return (
    <div className="flex flex-row mt-7 justify-between">
      <div className="flex flex-col">
        <div className="flex flex-row">
          <span
            className="text-sm"
            style={{
              fontStyle: "normal",
              fontWeight: 400,
              color: "#000000",
            }}
          >
            Version
          </span>
        </div>
        <div className="flex flex-row mt-3">
          <div
            className="flex text-sm h-12 w-56 items-center"
            style={{
              background: "#F5F5F5",
              border: "0.5px solid #8E8E8E",
              borderRadius: "4px",
              color: "#4F4F4F",
            }}
          >
            <span className="ml-3">{version}</span>
          </div>
        </div>
      </div>
      {id ? (
        <div className="flex flex-col">
          <Button
            label={"Edit"}
            iconLeft={Edit}
            className="bg-bt-green text-bt-white h-14 w-32 font-sora rounded-full"
            onClick={() => history.push(`/terms-conditions/${id}`)}
          />
        </div>
      ) : (
        <div className="flex flex-col">
          <Button
            label={"Save"}
            className="bg-bt-green text-bt-white h-14 w-32 font-sora rounded-full"
            onClick={handleSubmit}
          />
        </div>
      )}
    </div>
  );
};

export default TermsVersion;
